import { get } from 'lodash'
import { required, requiredFutureDate } from 'utils/validation'

export default function(values = {}) {
  const isExempted = get(values, 'isExempted')

  const isApplyCPNNeeded = get(values, 'isApplyCPNNeeded') || false

  return {
    childProtectionNumber: (!isApplyCPNNeeded && !isExempted) && required(get(values, 'childProtectionNumber')),
    childProtectionExpirationDate: (!isApplyCPNNeeded && !isExempted) && requiredFutureDate(
      get(values, 'childProtectionExpirationDate')
    ),
    section: {
      value: required(get(values, 'section.value'))
    }
  }
}
